
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { ISanityObjects, SanityObjectSchema } from '~/types/sanity-objects';

@Component
export default class NftCardReward extends Vue {
  @Prop(Object)
  readonly reward!: ISanityObjects[SanityObjectSchema.REWARD_ITEM];
}
